import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Listing from "../views/Listing.vue";
import Detail from "../views/Detail.vue";
import Account from "../views/Account.vue";
import NotFound from "../views/NotFound.vue";
import Groups from "../views/Groups.vue";
import AjoutDossier from "../views/AjoutDossier.vue";
import Password from "../views/Password.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import Logs from "../views/History.vue";
import Documents from "../views/Documents.vue";
import Cerfa from "../views/Cerfa.vue";
import Destinataires from "../views/Destinataires.vue";
import Users from "../views/Users.vue";
import Modeles from "../views/Modeles.vue";
import Statistics from "../views/Statistics.vue";
import Register from "../views/Register.vue";
import EmailValidation from "../views/EmailValidation.vue";
import BroadcastMessage from "../views/BroadcastMessage.vue";
import Maintenance from "../views/Maintenance.vue";
import MaintenanceManagement from "../views/MaintenanceManagement.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "dossiers",
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "MACS GDPR | Authentification",
    },
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: {
      title: "MACS GDPR | Register",
    },
  },
  {
    path: "/password/:token",
    name: "Password",
    component: Password,
    meta: {
      title: "MACS GDPR | Nouveau mot de passe",
    },
  },
  {
    path: "/validate-email/:token",
    name: "Emailvalidation",
    component: EmailValidation,
    meta: {
      title: "MACS GDPR | Validation de votre compte",
    },
  },
  {
    path: "/forgot-pass",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: {
      title: "MACS GDPR | Mot de passe oublié",
    },
  },
  {
    path: "/dossiers/:id",
    name: "Dossier",
    component: Detail,
    meta: {
      requiresAuth: true,
      title: "MACS GDPR | Détail demande",
    },
  },
  {
    path: "/account",
    name: "Account",
    component: Account,
    meta: {
      requiresAuth: true,
      title: "MACS GDPR | Mon compte",
    },
  },

  {
    path: "/user",
    name: "NewUser",
    component: Account,
    meta: {
      requiresAuth: true,
      title: "MACS GDPR | Nouvel utilisateur",
    },
  },

  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: {
      requiresAuth: true,
      title: "MACS GDPR | Liste des utilisateurs",
    },
  },

  {
    path: "/destinataires",
    name: "Destinataires",
    component: Destinataires,
    meta: {
      requiresAuth: true,
      title: "MACS GDPR | Liste des destinataires",
    },
  },

  {
    path: "/modeles",
    name: "Modeles",
    component: Modeles,
    meta: {
      requiresAuth: true,
      title: "MACS GDPR | Édition des modèles",
    },
  },

  {
    path: "/users/:id",
    name: "User",
    component: Account,
    meta: {
      requiresAuth: true,
      title: "MACS GDPR | Informations de l'utilisateur",
    },
  },

  {
    path: "/cerfa/:type/:id",
    name: "Cerfa",
    component: Cerfa,
    meta: {
      requiresAuth: true,
      title: "MACS GDPR | Visualisation Cerfa",
    },
  },
  {
    path: "/dossiers",
    name: "Dossiers",
    component: Listing,
    meta: {
      requiresAuth: true,
      title: "MACS GDPR | Liste des demandes", //,
      // roles: ['ROLE_GUICHET']
    },
  },
  {
    path: "/groups/:type",
    name: "Groupes",
    component: Groups,
    meta: {
      requiresAuth: true,
      title: "MACS GDPR | Groupes",
      roles: ["ROLE_ADMIN"],
    },
  },
  {
    path: "/history",
    name: "History",
    component: Logs,
    meta: {
      requiresAuth: true,
      title: "MACS GDPR | Historique",
      roles: ["ROLE_ADMIN"],
    },
  },
  {
    path: "/documents",
    name: "Documents",
    component: Documents,
    meta: {
      requiresAuth: true,
      title: "MACS GDPR | Documents",
      // roles: ["ROLE_ADMIN"],
    },
  },
  {
    path: "/statistics",
    name: "statistics",
    component: Statistics,
    meta: {
      requiresAuth: true,
      title: "MACS GDPR | Statistiques",
      // roles: ["ROLE_ADMIN"],
    },
  },
  {
    path: "/ajoutdossier/:choixForm",
    name: "ajoutdossier",
    component: AjoutDossier,
    meta: {
      requiresAuth: true,
      title: "MACS GDPR | Nouvelle demande", //,
      // roles: ['ROLE_GESTIONNAIRE']
    },
  },
  {
    path: "/updatedossier/:id",
    name: "updatedossier",
    component: AjoutDossier,
    meta: {
      requiresAuth: true,
      title: "MACS GDPR | Mise à jour de la demande",
      roles: ["ROLE_USER"],
    },
  },
  {
    path: "/message",
    name: "broadcastMessage",
    component: BroadcastMessage,
    meta: {
      requiresAuth: true,
      title: "MACS GDPR | Message général",
      roles: ['ROLE_SUPER_ADMIN']
    },
  },
  {
    path: "/maintenance",
    name: "Maintenance",
    component: Maintenance,
    meta: {
      title: "MACS GDPR | Maintenance",
    },
  },
  {
    path: "/maintenance-management",
    name: "MaintenanceManagement",
    component: MaintenanceManagement,
    meta: {
      title: "MACS GDPR | Gestion du mode maintenance",
      requiresAuth: true,
      roles: ["ROLE_SUPER_ADMIN"],
    },
  },
  {
    path: "/404",
    component: NotFound,
    meta: {
      title: "MACS GDPR | Page non trouvée",
      requiresAuth: true,
    },
  },
  {
    path: "/error",
    component: Error,
    meta: {
      title: "MACS GDPR | Service momentanément indisponible",
      requiresAuth: true,
    },
  },
  {
    path: "*",
    redirect: "/404",
  },
];

const router = new VueRouter({
    mode: "history",
    routes,
});

export default router;